export default "__VITE_ASSET__DddLoPaT__"